class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (url.includes('sort_by=brand')) { FacetFiltersForm.sortProductsByBrand(); }
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.syncProductCountFromGrid();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.syncProductCountFromGrid();
  }

  static syncProductCountFromGrid() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const actualCount = productGrid.querySelectorAll('li.grid__item').length;
    const hasPagination = document.querySelector('.pagination-wrapper') !== null;

    const drawerCountEl = document.getElementById('FilterDrawerProductCount');
    if (drawerCountEl) {
      if (actualCount === 0) {
        drawerCountEl.innerHTML = 'NO ITEMS FOUND';
      } else {
        drawerCountEl.innerHTML = `VIEW ${actualCount}${hasPagination ? '+' : ''} ITEMS`;
      }
    }

    if (!hasPagination) {
      ['ProductCountBar', 'ProductCount', 'ProductCountDesktop'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.innerHTML = el.innerHTML.replace(/\d+/, actualCount.toString());
      });
    }
  }

  static renderProductGridContainer(html) {
    const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    const newContainer = parsedDoc.getElementById('ProductGridContainer');

    newContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    document.getElementById('ProductGridContainer').innerHTML = newContainer.innerHTML;

    if (typeof window.initCardSwipers === 'function') window.initCardSwipers();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    const drawerCount = parsedDoc.getElementById('FilterDrawerProductCount');
    const barCount = parsedDoc.getElementById('ProductCountBar');
    if (drawerCount) {
      const drawerCountEl = document.getElementById('FilterDrawerProductCount');
      if (drawerCountEl) drawerCountEl.innerHTML = drawerCount.innerHTML;
    }
    if (barCount) {
      const barCountEl = document.getElementById('ProductCountBar');
      if (barCountEl) barCountEl.innerHTML = barCount.innerHTML;
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newSummary = countsToRender.querySelector('.mobile-facets__summary');
        const currentSummary = document.getElementById(closestJSFilterID).querySelector('.mobile-facets__summary');
        if (newSummary && currentSummary) {
          currentSummary.innerHTML = newSummary.innerHTML;
        }

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const newHeader = html.querySelector('.mobile-facets__header-inner');
    const currentHeader = document.querySelector('.mobile-facets__header-inner');
    if (newHeader && currentHeader) {
      currentHeader.innerHTML = newHeader.innerHTML;
    }

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static sortProductsByBrand() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    const products = Array.from(productGrid.children);
    
    products.sort((a, b) => {
      const brandA = this.getBrandFromElement(a);
      const brandB = this.getBrandFromElement(b);
      return brandA.localeCompare(brandB);
    });
    
    products.forEach(product => productGrid.appendChild(product));
  }
  
  static getBrandFromElement(element) {
    const productWrapper = element.querySelector('.product-card-wrapper');
    if (!productWrapper) return '';
    const brandData = productWrapper.getAttribute('data-brand');
    if (!brandData) return '';
    try {
      const cleanedBrandData = brandData.replace(/^\[|\]$/g, '');
      return cleanedBrandData.replace(/^"|"$/g, '');
    } catch (e) {
      return brandData;
    }
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm' ||
            form.id === 'FacetSortBarForm' ||
            form.id === 'FacetFiltersFormMobile'
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      const combined = new URLSearchParams(forms.join('&'));
      const eventFormParams = new URLSearchParams(this.createSearchParams(event.target.closest('form')));
      if (eventFormParams.has('sort_by')) {
        combined.delete('sort_by');
        combined.set('sort_by', eventFormParams.get('sort_by'));
      }
      this.onSubmitForm(combined.toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


/* original PriceRange 
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
*/
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.originalMinMax = null;
    this.originalMaxValue = null;
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setOriginalValues();
    this.setMinAndMaxValues();


    // FJS
    const sliderMin = document.getElementById('price-range-slider-min');
    const sliderMax = document.getElementById('price-range-slider-max');
    const inputMin = document.querySelector('.price-range-input-min');
    const inputMax = document.querySelector('.price-range-input-max');
    const priceRange = document.querySelector('.facets__price');
    const currencySymbol = priceRange.dataset.currencySymbol;
    const sliderTrackActive = document.querySelector('.price-range-slider-track-active');
    const originalMaxValue = parseInt(sliderMax.max);
    const originalRangeMax = originalMaxValue;
    const originalMinMax = sliderMin.min;
    
  
    function updateValues() {
      inputMin.value = sliderMin.value;
      inputMax.value = sliderMax.value;
      updateSliderTrackActive();
    }
  
    function updateSliderTrackActive() {
      const minValue = parseInt(sliderMin.value);
      const maxValue = parseInt(sliderMax.value);
      const trackWidth = ((maxValue - minValue) / originalRangeMax) * 100;
      sliderTrackActive.style.left = `${(minValue / originalRangeMax) * 100}%`;
      sliderTrackActive.style.width = `${trackWidth}%`;
    }
  
    function insertCurrencySymbol(input) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('price-range-currency-wrapper');
      const symbolSpan = document.createElement('span');
      symbolSpan.classList.add('price-range-currency-symbol');
      symbolSpan.textContent = currencySymbol;
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(symbolSpan);
      wrapper.appendChild(input);
    }
  
    insertCurrencySymbol(inputMin);
    insertCurrencySymbol(inputMax);
  
    const handleSliderInput = (slider, otherSlider) => {
      let value = parseInt(slider.value);
      let otherValue = parseInt(otherSlider.value);
  
      if (slider === sliderMin && value > otherValue) {
        value = otherValue;
        slider.value = otherValue;
      }
  
      if (slider === sliderMax && value < otherValue) {
        value = otherValue;
        slider.value = otherValue;
      }
  
      slider.min = originalMinMax;
      slider.max = originalMaxValue;
      otherSlider.min = originalMinMax;
      otherSlider.max = originalMaxValue;
  
      updateValues();
    };
  
    sliderMin.addEventListener('input', () => handleSliderInput(sliderMin, sliderMax));
    sliderMax.addEventListener('input', () => handleSliderInput(sliderMax, sliderMin));
  
    sliderMin.addEventListener('change', () => {
      sliderMin.min = originalMinMax;
      sliderMin.max = originalMaxValue;
      sliderMax.min = originalMinMax;
      sliderMax.max = originalMaxValue;
    });
  
    sliderMax.addEventListener('change', () => {
      sliderMin.min = originalMinMax;
      sliderMin.max = originalMaxValue;
      sliderMax.min = originalMinMax;
      sliderMax.max = originalMaxValue;
    });
  
    function resetMinMaxValues() {
      const minValue = parseInt(sliderMin.value);
      const maxValue = parseInt(sliderMax.value);
      if (minValue !== 0 || maxValue !== originalMaxValue) {
        sliderMin.min = originalMinMax;
        sliderMin.max = originalMaxValue;
        sliderMax.min = originalMinMax;
        sliderMax.max = originalMaxValue;
      }
    }
  
    let inputMinValue = '';
    let inputMaxValue = '';
    
    const handleInputChange = (input) => {
      let value = input.value.trim();
    
      if (value === '') {
        value = '0';
      }
    
      const numValue = parseInt(value);
      input.value = numValue;
    
      if (input === inputMin) {
        inputMinValue = numValue;
      } else if (input === inputMax) {
        inputMaxValue = numValue;
      }
    };
    
    const handleInputBlur = (input, slider, otherSlider) => {
      let value;
    
      if (input === inputMin) {
        value = inputMinValue;
      } else if (input === inputMax) {
        value = inputMaxValue;
      }
    
      const otherValue = parseInt(otherSlider.value);
    
      if (input === inputMin && value >= otherValue) {
        slider.value = otherValue - 1;
      } else if (input === inputMax && value < otherValue) {
        slider.value = otherValue;
      } else {
        slider.value = value;
      }
    
      handleSliderInput(slider, otherSlider);
      updateSliderTrackActive();
      resetMinMaxValues();
    };
    
    const handleInputKeyUp = (event, input, slider, otherSlider) => {
      if (event.key === 'Enter') {
        handleInputBlur(input, slider, otherSlider);
        updateSliderTrackActive();
        updateValues();
      }
    };

    const handleInputKeyDown = (event, input, slider, otherSlider) => {
      if (event.key === 'Enter') {
        handleInputBlur(input, slider, otherSlider);
        updateSliderTrackActive();
        updateValues();
      }
    };

    const handleInputKeyPress = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    };
    
    inputMin.addEventListener('input', () => handleInputChange(inputMin));
    inputMax.addEventListener('input', () => handleInputChange(inputMax));
    
    inputMin.addEventListener('blur', () => handleInputBlur(inputMin, sliderMin, sliderMax));
    inputMax.addEventListener('blur', () => handleInputBlur(inputMax, sliderMax, sliderMin));
    
    inputMin.addEventListener('keyup', (event) => handleInputKeyUp(event, inputMin, sliderMin, sliderMax));
    inputMax.addEventListener('keyup', (event) => handleInputKeyUp(event, inputMax, sliderMax, sliderMin));
    inputMin.addEventListener('keydown', (event) => handleInputKeyDown(event, inputMin, sliderMin, sliderMax));
    inputMax.addEventListener('keydown', (event) => handleInputKeyDown(event, inputMax, sliderMax, sliderMin));
    inputMin.addEventListener('keypress', (event) => handleInputKeyPress(event));
    inputMax.addEventListener('keypress', (event) => handleInputKeyPress(event));
  
    resetMinMaxValues();
    updateValues();
    }

  onRangeChange(event) {
    const slider = event.currentTarget;
    const otherSlider = slider.id === 'price-range-slider-min' ? this.querySelector('#price-range-slider-max') : this.querySelector('#price-range-slider-min');
    this.adjustToValidValues(slider, otherSlider);
    this.setMinAndMaxValues();
    this.updateSliderTrackActive();
    const sliderMin = this.querySelector('#price-range-slider-min');
    const sliderMax = this.querySelector('#price-range-slider-max');
    console.log('this.originalMaxValue:', this.originalMaxValue);

    if (sliderMin.min === 0 && sliderMax.max === this.originalMaxValue) {
      // Si el rango es el rango completo, evitar la aplicación del filtro
      console.log('Filtro no aplicado: Rango completo seleccionado');
      event.preventDefault();
    } else {
      console.log('Filtro aplicado');
    }
  }

  setOriginalValues() {
    const sliderMin = this.querySelector('#price-range-slider-min');
    const sliderMax = this.querySelector('#price-range-slider-max');
    if (sliderMin && sliderMax) {
      this.originalMinMax = sliderMin.min;
      this.originalMaxValue = parseInt(sliderMax.max);
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const sliderMin = this.querySelector('#price-range-slider-min');
    const sliderMax = this.querySelector('#price-range-slider-max');

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', this.originalMaxValue);

    if (sliderMin && sliderMax) {
      sliderMin.min = this.originalMinMax;
      sliderMax.max = this.originalMaxValue;
    }

    const inputMin = this.querySelector('.price-range-input-min');
    const inputMax = this.querySelector('.price-range-input-max');
    if (inputMin && inputMax) {
      inputMin.value = sliderMin.value;
      inputMax.value = sliderMax.value;
    }
  }

  adjustToValidValues(slider, otherSlider) {
    let value = Number(slider.value);
    let otherValue = Number(otherSlider.value);

    if (slider.id === 'price-range-slider-min' && value > otherValue) {
      value = otherValue;
      slider.value = otherValue;
    }

    if (slider.id === 'price-range-slider-max' && value < otherValue) {
      value = otherValue;
      slider.value = otherValue;
    }

    const min = Number(this.originalMinMax);
    const max = Number(this.originalMaxValue);

    if (value < min) slider.value = min;
    if (value > max) slider.value = max;
  }

  updateSliderTrackActive() {
    const sliderTrackActive = this.querySelector('.price-range-slider-track-active');
    if (sliderTrackActive) {
      const minSlider = this.querySelector('#price-range-slider-min');
      const maxSlider = this.querySelector('#price-range-slider-max');

      const minValue = parseInt(minSlider.value);
      const maxValue = parseInt(maxSlider.value);
      const trackWidth = ((maxValue - minValue) / this.originalMaxValue) * 100;
      sliderTrackActive.style.left = `${(minValue / this.originalMaxValue) * 100}%`;
      sliderTrackActive.style.width = `${trackWidth}%`;
    }
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);